import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '../../../components';
import StackedPercentageAreaChart from '../../../charts/StackedPercentageAreaChart';
import { dataToStackChartData } from '../../../../services/data/charts/dataToStackChartData';
import { useGetAppAdminSdkVersionPerDayQuery } from '../../../../api/appAdminApiSlice';
import Block from '../../../Block';

const DevicePerSdkVersionEvolution = ({appId, ...props}) => {
  const { t } = useTranslation();
  const {data = [], isSuccess, isError, refetch} = useGetAppAdminSdkVersionPerDayQuery(appId)
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const stackData = dataToStackChartData("sdk_version")(data)
  const androidData = dataToStackChartData("sdk_version")(data.filter( (x)=>(x.os === "android" )))

  return (
    <Block title={t('version.device_per_sdk_version_evolution')} {...props}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <StackedPercentageAreaChart  data={stackData} legendOptions={{show: false}} />
      </Loader>
    </Block>
  )
}

export default DevicePerSdkVersionEvolution
